import { reviewEnum } from "../../enums/reviewEnum";

export default (informations) => ({
  exchangeSucceed: informations?.exchangeSucceed || reviewEnum.YES.mainText,
  correctCommunication:
    informations?.correctCommunication || reviewEnum.YES.mainText,
  comment: informations?.comment || "",
});
